// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.

// Cookies - For Keeping User Preference

var isMobile = false;
var isTablet = false;
var isLandscape = false;


var currentWidth = 0;
var currentHeight = 0;

checkIfMobile = function () {
    // get browser width
    currentWidth = window.innerWidth || document.documentElement.clientWidth;
    currentHeight = window.innerHeight || document.documentElement.clientHeight;
    
    isLandscape = (currentWidth > currentHeight);

    var md = new MobileDetect(navigator.userAgent)

    isMobile = (md.phone() != null);
    isTablet = (md.tablet() != null);

    //detect known mobile/tablet usage
    //if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i)) || (navigator.userAgent.match(/Android/i)) || (navigator.userAgent.match(/Blackberry/i)) || (navigator.userAgent.match(/Windows Phone/i))) {
    //    isMobile = true;
    //}else if (navigator.userAgent.match(/iPad/i)) {
    //    isTablet = true;
    //}
};

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function setMode(sMode, sColor) {
    //debugger;

    if ((sMode.indexOf("auto") == 0) && (!$("body").hasClass("auto"))) {
        return; // don't set mode if auto is not set
    }

    if (sMode === "set-auto") {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            sMode = "auto dark-mode";
        } else {
            sMode = "auto light-mode";
        }
    }

    $("body").removeClass("light-mode")
        .removeClass("auto")
        .removeClass("dark-mode")
        .removeClass("blue")
        .removeClass("purple");

    if ((sMode === "dark-mode") || (sMode === "auto dark-mode")) {

    } else if (((sMode === "light-mode") || (sMode === "auto light-mode")) && (sColor == "")) {
        sColor = getCookie("site-color") || "blue"; // default color for light mode  
    }

    $("body").addClass(sMode + " " + sColor);

    setCookie("site-color", sColor, 365);
    setCookie("site-view-mode", sMode, 365);
}

formatLocalDateTime = function (iUnixTimeStamp, sformat) {

    if (sformat === undefined) {
        sformat = "d/m/y h:m:s"
    }

    return formatLocalTime(iUnixTimeStamp, sformat)
};

formatLocalTime = function (iUnixTimeStamp, sformat) {
    if (sformat === undefined) {
        sformat = "h:m"
    }
    if (iUnixTimeStamp == null) {
        iUnixTimeStamp = 0;
    }
    if (iUnixTimeStamp == 0) {
        return "--:--";
    } else {
        var d = new Date(iUnixTimeStamp);

        return formatDateTime(d, sformat);
    }
};

downloadExport = function (obj) {
    var $this = $(obj);

    if (!$this.hasClass("disabled")) {
        $this.addClass("disabled");

        var sContent = "<div class=\"text-center py-5 px-2\">"
            + "    <div class=\"text-center\">"
            + "        <i class=\"fa-3x mb-2 fas fa-sync-alt fa-sync-alt fas text-green animation__rotate\"></i>"
            + "    </div>"
            + "    <p class=\"lead text-center\">Processing Please Wait</p>"
            + "</div>";

        loadLocalContent("overlay-content", sContent, true, "md", "Exporting Data");

        $.ajax({
            type: "GET",
            url: $this.attr("href"),
            cache: false,
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob'
                return xhr;
            },
            success: function (data, textStatus, xhr) {
                //debugger;
                $this.removeClass("disabled", false);

                if (textStatus.indexOf("error") > -1) {
                    loadLocalContent("overlay-content", "<p class=\"alert alert-danger\">Error exporting data - please try again.</p>", true, "md", "Exporting Data Error");
                } else {
                    //var blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    //var blob = new Blob([data], { type: "application/octet-stream" });
                    var blob = data;
                    var filename = "";
                    var disposition = xhr.getResponseHeader('Content-Disposition');

                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }

                    //Check the Browser type and download the File.
                    var isIE = false || !!document.documentMode;

                    if (isIE) {
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var url = window.URL || window.webkitURL;

                        try {
                            link = url.createObjectURL(blob);
                        } catch (e) {
                            link = url.createObjectURL(new Blob([data], { type: "application/octet-stream" }));
                        }

                        var sDownloadContent = "<div class=\"text-center py-5 px-2\">"
                            + "    <div class=\"text-center\">"
                            + "        <i class=\"fa-3x mb-2 fas fa-check-circle fas text-green animation__wobble\"></i>"
                            + "    </div>"
                            + "    <p class=\"lead text-center\">Export Complete</p>"
                            + "    <p>If your file doesn't automatically download <span id=\"download-link\"></span>.<p>"
                            + "</div>";

                        loadLocalContent("overlay-content", sDownloadContent, true, "md", "Export Data");

                        var a = $("<a>click here</a>");
                        a.attr("download", filename);
                        a.attr("href", link);

                        $("#download-link").append(a);
                        a[0].click();
                    }
                }
            },
            failure: function (response) {
                $this.removeClass("disabled", false);

                if (response.indexOf("error") > -1) {
                    loadLocalContent("overlay-content", "<p class=\"alert alert-danger\">Error exporting data - please try again.</p>", true, "md", "Exporting Data Error");
                }
            },
            error: function (response) {
                $this.removeClass("disabled", false);

                if ((response !== null) && (response !== undefined) && (response !== "")) { 
                    if (response.statusText.indexOf("error") > -1) {
                        loadLocalContent("overlay-content", "<p class=\"alert alert-danger\">Error exporting data - please try again.</p>", true, "md", "Exporting Data Error");
                    }
                }
            }
        });

        return false;
    }
};

bindControls = function ($obj) {
    $obj.find('[data-mask]').each(function (idx, obj) {
        //$(obj).inputmask()
    });

    $obj.find('.wysiwyg').each(function (idx, obj) {
        $(obj).summernote({
            styleTags: [
                'p',
                { title: 'Small Text', tag: 'p', className: 'small-text', value: 'p' },
                'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
            ]});
    });

    $obj.find('.seachableDDL').each(function (idx, obj) {
        $(obj).select2();
    });

    $obj.find('.colourPickerUI').each(function (idx, obj) {
        //color picker with addon
        $(obj).colorpicker()

        $(obj).find('.input-group-append').on("click", function () {
            $(obj).find("input").focus();
        });


        $(obj).on('colorpickerChange', function (event) {
            $(obj).find('.fa-square').css('color', event.color.toString());
        });
    });

    $obj.find('.datePickerUI').each(function (idx, obj) {
        $(obj).datetimepicker({
            format: 'DD MMM yyyy',
            allowInputToggle: true,
            keepOpen: false,
            debug: true,
            buttons: {
                showToday: true,
                showClear: true,
                showClose: true
            },
            icons: {
                time: "far fa-clock",
                date: "far fa-calendar-alt",
                up: "fa fa-arrow-up",
                down: "fa fa-arrow-down",
                clear: "far fa-calendar-times",
                close: "far fa-times-circle",
                today: 'far fa-calendar-check'
            }
        });
    });

    $obj.find('.datetimePickerUI').each(function (idx, obj) {
        $(obj).datetimepicker({
            format: 'DD MMM yyyy HH:mm',
            allowInputToggle: true,
            keepOpen: false,
            buttons: {
                showToday: true,
                showClear: true,
                showClose: true
            },
            icons: {
                time: "far fa-clock",
                date: "far fa-calendar-alt",
                up: "fa fa-arrow-up",
                down: "fa fa-arrow-down",
                clear: "far fa-calendar-times",
                close: "far fa-times-circle",
                today: 'far fa-calendar-check'
            }
        });
    });

    $obj.find('.timePickerUI').each(function (idx, obj) {
        $(obj).datetimepicker({
            format: 'HH:mm',
            allowInputToggle: true,
            keepOpen: false
        });

        $(obj).find("input").on("focus", function () {
            $(obj).datetimepicker("show");
        });

        $(obj).find("input").on("blur", function () {
            $(obj).datetimepicker("hide");
        });

        $(obj).on("change.datetimepicker", function (e) {
            //debugger;
        });

        $(obj).on("update.datetimepicker", function (e) {
            //debugger;
        });
    });

    $obj.find("input[type=file]").each(function (idx, obj) {
        $(obj).on("change", function () {
            var fileName = $(this).val();

            if (fileName !== "") {
                if (fileName.indexOf("\\") > 0) {
                    aPathParts = fileName.split("\\");

                    if (aPathParts.length > 0) {
                        fileName = aPathParts[aPathParts.length - 1];
                    }
                }
            } else {
                fileName = "Choose file";
            }


            $(this).next('.custom-file-label').html(fileName);
        });
    });

    $obj.find('.pincode_show').each(function (idx, obj) {
        var $inp = $(this).find("input[type=password]");
        var $showPass = $('<div class="border far my-1 p-2 rounded text-center" style=\"min-width: 37px;\"><i class="far fa-eye-slash"></i></div>');
        var $restart = $('<div class="border far my-1 p-2 rounded text-center"  style=\"min-width: 37px;\"><i class="fas fa-undo"></i></div>');

        var $controls = $('<div class="align-items-start col-2 d-flex flex-column"></div>');

        $controls.append($showPass);
        $controls.append($restart);

        $(obj).append($controls);

        $showPass.on("click", function () {
            if ($inp.attr("type") == "password") {
                $inp.attr("type", "text");
                $(this).html("<i class=\"far fa-eye\"></i>");
            } else {
                $inp.attr("type", "password");
                $(this).html("<i class=\"far fa-eye-slash\"></i>");
            }
        });

        $restart.on("click", function () {

            $inp.each(function (i, input) { $(input).val(''); });

            $inp[0].focus()
        });

        $inp.each(function (idx, obj) {
            if (idx !== 0) {
                $(obj).on("click", function () {

                    if ((this.value) && (idx != ($inp.length - 1))) {
                        for (i = 0; i < $inp.length; i++) {
                            if ($inp[i].value == "") {
                                $inp[i].focus();
                                return;
                            };
                        }
                    }

                    $inp[0].focus();
                });
            }


            $(obj).on("keyup", function (e) {
                //debugger;
                //console.log("key up " + e.key);

                if (e.key === "Backspace") {
                    if ((this.value == "") && (idx !== 0)) {
                        $inp[idx - 1].focus();
                    }
                    return;
                }

                if (e.key === "ArrowLeft") {
                    if (idx !== 0) {
                        $inp[idx - 1].focus();
                    }

                    return;
                }

                if (e.key === "ArrowRight") {
                    if (idx !== ($inp.length - 1)) {
                        $inp[idx + 1].focus();
                    }

                    return;
                }

                //if (e.key === "Enter") {

                //    e.preventDefault();

                //    $(this).closest("form").submit();

                //    return;
                //}

                if ((this.value) && (idx != ($inp.length - 1))) {
                    $inp[idx + 1].focus();
                }
            });

            $(obj).on("paste", function (e) {
                //debugger;
                const paste = e.originalEvent.clipboardData.getData('text')

                $inp.each(function (i, input) { $(input).val(paste[i] || ''); });

                $inp[$inp.length -1].focus()
            });
        });
    });

    $obj.find('.pass_show').each(function (idx, obj) {
        //debugger;

        var $inp = $(this).find("input[type=password]");

        var $showPass = $('<div class="input-group-prepend"><i class="far fa-eye-slash"></i></div>');

        $(obj).prepend($showPass);

        $showPass.on("click", function () {
            if ($inp.attr("type") == "password") {
                $inp.attr("type", "text");
                $(this).html("<i class=\"far fa-eye\"></i>");
            } else {
                $inp.attr("type", "password");
                $(this).html("<i class=\"far fa-eye-slash\"></i>");
            }
        });
    });

    $obj.find('input[type="password"][data-toggle=popover]').on('keyup', function () {
        var iMinummLength = 8;

        if ($(this).attr("data-val-length-min") !== undefined) {
            iMinummLength = parseInt($(this).attr("data-val-length-min"));
        }

        //minimum 8 characters
        var bad = new RegExp(`/(?=.{${iMinummLength},}).*/`);

        //Alpha Numeric plus minimum 8
        var good = new RegExp(`/^(?=\S*?[a-z])(?=\S*?[0-9])\S{8,}$/`);

        //Must contain at least one upper case letter, one lower case letter and (one number OR one special char).
        var better = new RegExp(`/^(?=\S*?[A-Z])(?=\S*?[a-z])((?=\S*?[0-9])|(?=\S*?[^\w\*]))\S{${iMinummLength},}$/`);

        //Must contain at least one upper case letter, one lower case letter and (one number AND one special char).
        var best = new RegExp(`/^(?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[^\w\*])\S{${iMinummLength},}$/`);

        var password = $(this);
        var pass = password.val();
        var passLabel = $('[for="password"]');

        var stength = 'Weak';
        var pclass = 'danger';

        if (best.test(pass) == true) {
            stength = 'Very Strong';
            pclass = 'success';
        } else if (better.test(pass) == true) {
            stength = 'Strong (Try adding a number or a symbol or a Uppercase)';
            pclass = 'warning';
        } else if (good.test(pass) == true) {
            stength = 'Almost Strong (At least 1 number, At least 1 symbol, At least 1 Uppercase)';
            pclass = 'warning';
        } else if (bad.test(pass) == true) {
            stength = 'Weak (At least 1 number, At least 1 symbol)';
        } else {
            stength = 'Very Weak (Must be ' + iMinummLength + ' or more characters, At least 1 number, At least 1 symbol, At least 1 Uppercase)';
        }

        var popover = password.attr('data-content', stength).data('bs.popover');

        popover.setContent();

        var $tip = $(popover.tip);

        $tip.removeClass('danger success info warning primary').addClass(pclass);

    });

    $obj.find('input[data-toggle="popover"]').popover({
        placement: 'top',
        trigger: 'focus'
    });

    $obj.find('i[data-toggle="popover"]').popover({
        placement: 'left',
        trigger: 'hover'
    });

    $obj.find('span[data-toggle="popover"]').popover({
        placement: 'bottom',
        trigger: 'click',
        container: '#siteMain'
    });

    $obj.find('button[data-toggle="popover"]').popover({
        placement: 'bottom',
        trigger: 'focus',
        container: '#siteMain'
    });


    $obj.find('[data-toggle="lightbox"]').on('click', function (event) {
        event.preventDefault();

        $(this).ekkoLightbox();
    });
}

validateForm = function (form) {
    var $form = $(form);

    $form.removeData("validator");
    $form.removeData("unobtrusiveValidation");

    $.validator.unobtrusive.parse($form);

    $form.validate();

    return $form.valid();
};

$(window).ready(function () {
    checkIfMobile();

	var nav_cookie = getCookie("setNav"),
		body = $("body");

	if (nav_cookie === "full-menu") {
		body.removeClass("sidebar-collapse");
	}
	if (nav_cookie === "mini-menu") {
		body.addClass("sidebar-collapse");
	}

	var menutogglers = $("a[data-widget='pushmenu']");

    menutogglers.each(function (idx, obj) {
        $(obj).on("click", function () {
            if (body.hasClass("sidebar-collapse")) {
                setCookie("setNav", "full-menu", 30);
                //console.log("cookie: setNav = " + nav_cookie);
            } else {
                setCookie("setNav", "mini-menu", 30);
                //console.log("cookie: setNav = " + nav_cookie);
            }
        });
    });

    bindControls($(this));

    $(".alert-dismissible").each(function (idx, obj) {
        var $obj = $(obj);

        if ($obj.data("autohide") === true) {
            var iTimout = $obj.data("autohidedelay");

            setTimeout(function () {
                $obj.slideUp(500);
            }, iTimout);
        }
    });

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setMode("auto dark-mode", "");
    } else {
        setMode("auto light-mode", "");
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
        const newColorScheme = event.matches ? "dark" : "light";

        if (newColorScheme === "dark") {
            setMode("auto dark-mode", "");
        } else {
            setMode("auto light-mode", "");
        };
    });
});

//if ('serviceWorker' in navigator) {
//    window.addEventListener("load", () => {
//        navigator.serviceWorker.register("/js/ServiceWorker.js");
//    });
//}